<template><div class="d-flex justify-center">

<div style="max-width: 600px; width: 100%" class="pa-2">

    <v-autocomplete
    	class="pt-5"
        v-model="cur_word"
        :items="nao_list"
        outlined
        dense
        label="Enter Nao element"
        clearable
    ></v-autocomplete>

    <v-checkbox v-if="cur_word == null" v-model="show_opposites" label="Show opposites" > </v-checkbox>
    <Element v-if="cur_word !== null" :e="word_arr[0]"/>

	<v-lazy
		v-show="cur_word === null"
		v-for="e in elements_to_show"
        :value="false"
        min-height="100"
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
    >
    	<Element :e="e"/>
	</v-lazy>
</div>

</div></template>

<script>

import Element from '@/components/Element'

export default {
	components: {Element},
	data() {
		return {
			lazy_active: {},
			cur_word: null,
			show_opposites: false,
		}
	},
	methods: {
		verb_descr(attrs) {
			return attrs.includes('repsubj') ? 'verb (repsubj)' : 'verb';
		}
	},
	computed: {
		k() {
			return 'd-flex justify-center align-center text-h4 elem ' + this.$css.naoword;
		},
		nao_list() {
			return this.elements.map(x => x.nao);
		},
		word_arr() {
			return this.elements.filter(x => x.nao == this.cur_word);
		},
		elements_to_show() {
			if (this.show_opposites) return this.elements;
			else return this.elements.filter(x => !x.attrs.includes("opp") ) ;
		}
	},
	created() {
		this.elements = this.$nao.get_elements_cards() ;
	}
}
</script>